
import purple from "@material-ui/core/colors/purple";
export const styles = (theme) => ({
    icon: {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(2),
    },
    locationForm: {
      width: "100%",
      height: "100%",
      opacity: "0.8",
      overflowY: "auto",
      padding: 2,
      marginBottom: -28,
    },
    margin: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    overflowY: {
      overflowY: "auto",
    },
    positionIcon: {
      padding: 0,
    },
    buttonItems: {
      padding: 4,
      "&:hover span": {
        color: purple[800],
      },
    },
    fullHeight: {
      height: "100%",
    },
    positionListText: {
      marginRight: 60,
    },
    paddingTop10: {
      paddingTop: 10,
    },
    mainPoint: {
      paddingTop: 10,
    },
    enableFormValues: {
      position: "absolute",
      background: "#ccc",
      opacity: 0.8,
      zIndex: 9,
    },
    paginationContainer: {
      position: "absolute",
      zIndex: 1,
      background: "transparent",
      overflowY:'auto'
    },
    pagination: {
      bottom: "0",
      marginLeft: "auto",
      marginRight: "auto",
      width: "345px",
    },
    marker: {
      zIndex: 2,
    },
    mapWaiting:{
      marginLeft: 'auto',
      marginRight:'auto'
    }
  });
  